import { API, getAsyncThunk } from '../../api';

export const getUnreadNotificationsCount = getAsyncThunk(
  'NOTIFICATIONS:GET_UNREAD_NOTIFICATIONS_COUNT',
  API.notifications.getUnreadNotificationsCount,
);
